export function downloadCSV(data: any[], filename: string) {
  if (!data || data.length === 0) return

  // Get all unique keys from all objects
  const keys = Array.from(new Set(data.flatMap(Object.keys)))

  // Create CSV header
  const header = keys.join(',')

  // Create CSV rows
  const rows = data.map((row) => {
    return keys
      .map((key) => {
        let value = row[key]

        // Handle null/undefined
        if (value === null || value === undefined) return ''

        // Handle arrays (e.g., authors, keywords)
        if (Array.isArray(value)) {
          value = value.join('; ')
        }

        // Convert to string
        value = String(value)

        // Escape quotes and wrap in quotes if contains comma, quote, or newline
        if (value.includes(',') || value.includes('"') || value.includes('\n')) {
          value = '"' + value.replace(/"/g, '""') + '"'
        }

        return value
      })
      .join(',')
  })

  // Combine header and rows
  const csv = [header, ...rows].join('\n')

  // Create download link
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
